import EditPaper from "./EditPaper";

export default EditPaper;
